import { render } from "./QuestionCardMultiSelect.vue?vue&type=template&id=31f22b14"
import script from "./QuestionCardMultiSelect.vue?vue&type=script&lang=js"
export * from "./QuestionCardMultiSelect.vue?vue&type=script&lang=js"

import "./QuestionCardMultiSelect.vue?vue&type=style&index=0&id=31f22b14&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__